import request from '@/sheep/request';

const HealthCheckinApi = {
  // 获取本周健康打卡数据
  getWeekStatistics: (params) => request({
    url: '/operation/health-checkin/week-statistics',
    method: 'GET',
    params,
  }),

  // 提交健康打卡
  create: (data) => request({
    url: '/operation/health-checkin/create',
    method: 'POST',
    data,
  }),
};

export default HealthCheckinApi;
